import { createAction, props } from '@ngrx/store';
import { Update, EntityMap, EntityMapOne } from '@ngrx/entity';
import { IDjangoPaginationData } from '@shared/ui-components/au-paginator/pagination-page.info';
import { AuGqlError } from '@app/shared';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import { ICmmsWorkOrderQueryVariables } from '@app/domain/gql/types';
import {
	IWorkOrder,
	IWorkOrderEditPayload,
} from '@app/domain/cmms-types/workorder-types';

export const loadDefaultWorkOrders = createAction(
	'[WO] Load work order with default variables'
);

export const startLoadingWorkOrders = createAction(
	'[WO] Start loading work orders',
	props<{ variables: ICmmsWorkOrderQueryVariables }>()
);

export const workOrdersFailedToLoad = createAction('[WO] Work orders failed to load');

export const workOrdersLoaded = createAction(
	'[WO] Work orders loaded',
	props<{
		workOrderPagination: IDjangoPaginationData;
		workOrders: IWorkOrder[];
	}>()
);

export const storeWorkOrdersQueryVariables = createAction(
	'[WO] Store work orders query variables',
	props<{ variables: ICmmsWorkOrderQueryVariables }>()
);

export const dropWorkOrdersQueryVariables = createAction(
	'[WO] Drop work orders query variables'
);

export const setWorkOrderForEditing = createAction(
	'[WO] Add work order for editing',
	props<{
		workOrderEdit: IWorkOrder;
	}>()
);

export const setWorkOrders = createAction(
	'[WO] Set work orders',
	props<{ workOrders: IWorkOrder[] }>()
);
export const startCreateWorkOrder = createAction(
	'[WO] Start create work order',
	props<{
		workOrder: IWorkOrderEditPayload;
		skipTableReload?: boolean;
		closeSidebar: boolean;
	}>()
);
export const createWorkOrderSuccess = createAction(
	'[WO] Create work order success',
	props<{ workOrder: IWorkOrder; skipTableReload?: boolean }>()
);
export const createWorkOrderError = createAction(
	'[WO] Create work order error',
	props<{ error?: AuGqlError }>()
);
export const addWorkOrder = createAction(
	'[WO] Add work order',
	props<{ workOrder: IWorkOrder }>()
);
export const setWorkOrder = createAction(
	'[WO] Set work order',
	props<{ workOrder: IWorkOrder }>()
);
export const setWorkOrderForEdit = createAction(
	'[WO] Set work order for edit',
	props<{ workOrder: IWorkOrder }>()
);
// update one or insert one work order
export const upsertWorkOrder = createAction(
	'[WO] Upsert work order',
	props<{ workOrder: IWorkOrder }>()
);
export const addWorkOrders = createAction(
	'[WO] Add work orders',
	props<{ workOrders: IWorkOrder[] }>()
);
// update one or insert one work order array
export const upsertWorkOrders = createAction(
	'[WO] Upsert work orders',
	props<{ workOrders: IWorkOrder[] }>()
);
export const startUpdateWorkOrder = createAction(
	'[WO] Start update work order',
	props<{ workOrder: Partial<IWorkOrderEditPayload> }>()
);
export const updateWorkOrderSuccess = createAction(
	'[WO] Update work order success',
	props<{ workOrder: IWorkOrder }>()
);
export const updateWorkOrder = createAction(
	'[WO] Update work order in state',
	props<{ update: Update<IWorkOrder> }>()
);
export const updateWorkOrders = createAction(
	'[WO] Update work orders',
	props<{ updates: Update<IWorkOrder>[] }>()
);
export const mapWorkOrder = createAction(
	'[WO] Map work order',
	props<{ entityMap: EntityMapOne<IWorkOrder> }>()
);
export const mapWorkOrders = createAction(
	'[WO] Map work orders',
	props<{ entityMap: EntityMap<IWorkOrder> }>()
);
export const startDeletingWorkOrder = createAction(
	'[WO] Start deleting work order',
	props<{ pk: string }>()
);
export const deletingWorkOrderSuccess = createAction(
	'[WO] Deleting work order success',
	props<{ pk: string }>()
);
export const deleteWorkOrderFromState = createAction(
	'[WO] Delete work order from state',
	props<{ pk: string }>()
);
export const deleteWorkOrders = createAction(
	'[WO] Delete work orders',
	props<{ pks: string[] }>()
);

export const openWorkOrderWorkspaceFromOutside = createAction(
	'[WO] Open work order workspace from outside',
	props<{ pk: string }>()
);

export const openNewWorkOrderFromOutside = createAction(
	'[WO] Open new work order workspace from outside',
	(workOrderData = null) => ({ workOrderData })
);

export const setWorkOrdersTableConfig = createAction(
	'[WO] Set work orders table config',
	props<{
		isExportable: boolean;
		columns: ICMMSColumn[];
	}>()
);

export const setWorkOrderSelectedCalendarDate = createAction(
	'[WO] Set work order selected calendar date',
	props<{
		selectedDate: string; // '2023-10-25'
	}>()
);

export const addWorkOrderExternalData = createAction(
	'[WO] Add wo external data',
	(workOrderData = null) => ({ workOrderData })
);

export const clearWorkOrderExternalData = createAction('[WO] Clear wo external data');
